import UserDashboard from './UserDashboard';

const Dashboard = () => {
  return <UserDashboard />;
};

export default Dashboard;


// # End of file
